import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../../badRequestHandler/BadRequestHandler";

export const getReportTicketsApi = createApi({
  reducerPath: "getReportTickets",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getAllTeams: builder.query({
      query: () => ({
        url: "v1/users/me/",
        method: "GET",
      }),
    }),

    getAllWorkflows: builder.query({
      query: () => ({
        url: "v1/tickets/ticket-name/workflow-list/",
        method: "GET",
      }),
    }),

    getAllAssigneeBySelectedTeamId: builder.query({
      query: (teams__id) => ({
        url: `v1/users/users/?teams__id=${teams__id}&`,
        method: "GET",
      }),
    }),

    getAllWorkflowSelectedTeamId: builder.query({
      query: (teams__id) => ({
        url: `v1/tickets/ticket-name/?team_id=${teams__id}&`,
        method: "GET",
      }),
    }),

    getAllTeamsSelectedWorkflowId: builder.query({
      query: (workflow_id) => ({
        url: `v1/tickets/ticket-name/teams-by-workflow/?workflow_id=${workflow_id}`,
        method: "GET",
      }),
    }),

    getTicketLifeCycleReport: builder.query({
      query: ({
        gte,
        lte,
        team_id,
        team_ids,
        action__assignee,
        workflow_id,
      }) => ({
        url: `v1/reports/ticket-lifecycle-report/`,
        method: "GET",
        params: {
          gte,
          lte,
          team_id,
          team_ids,
          action__assignee,
          workflow_id,
        },
      }),
    }),

    getIssueTypeWiseTATReport: builder.query({
      query: ({ gte, lte, team_ids, team_id }) => ({
        url: `v1/reports/sla-reports/`,
        method: "GET",
        params: {
          gte,
          lte,
          report_type: "issue_level",
          result_format: "list",
          team_ids,
          team_id,
        },
      }),
    }),

    getSubIssueTypeWiseTATReport: builder.query({
      query: ({ gte, lte, team_ids, team_id }) => ({
        url: `v1/reports/sla-reports/`,
        method: "GET",
        params: {
          gte,
          lte,
          report_type: "sub_issue_level",
          result_format: "list",
          team_ids,
          team_id
        },
      }),
    }),

    getDepartmentWiseTATReport: builder.query({
      query: ({ gte, lte, team_ids, team_id }) => ({
        url: `v1/reports/sla-reports/`,
        method: "GET",
        params: {
          gte,
          lte,
          report_type: "team_level",
          result_format: "list",
          team_ids,
          team_id
        },
      }),
    }),

    getAuditTicktetWiseReport: builder.query({
      query: ({ gte, lte, team_ids, team_id }) => ({
        url: `v1/reports/sla-reports/`,
        method: "GET",
        params: {
          gte,
          lte,
          report_type: "audit",
          result_format: "list",
          team_ids,
          team_id
        },
      }),
    }),

    getLatestStatusReport: builder.query({
      query: ({ gte, lte, team_id, team_ids, status_type , workflow_id}) => ({
        url: `v1/reports/sla-reports/`,
        method: "GET",
        params: {
          gte,
          lte,
          report_type: "latest_status_of_tickets",
          result_format: "list",
          team_id,
          team_ids,
          status_type,
          workflow_id
        },
      }),
    }),


    //  Telephoney report

    getAllUserList: builder.query({
      query: ({ }) => ({
        url: `v1/users/users/?`,
        method: "GET",
      }),

    }),


    getLoginAndLogoutReport: builder.query({
      query: ({ gte, lte, user_id }) => ({
        url: `v1/users/telephony-login/`,
        method: "GET",
        params: {
          gte,
          lte,
          user_id,
        },
      }),
    }),

    getAgentPerformanceReport: builder.query({
      query: ({ gte, lte, user_id, call_type }) => ({
        url: `v1/reports/telephony-agent-performance/`,
        method: "GET",
        params: {
          gte,
          lte,
          user_id,
          call_type
        },
      }),
    }),

    getAllQueue: builder.query({
      query: () => ({
        url: `v1/telephony/queues/`,
        method: "GET",
      }),

    }),



    getCallDetailsReport: builder.query({
      query: ({ gte, lte, user_id, call_type, queue }) => ({
        url: `v1/users/call-history/`,
        method: "GET",
        params: {
          gte,
          lte,
          user_id,
          call_type,
          queue
        },
      }),
    }),
    getCallDetailsReportfetchrecording: builder.query({
      query: ({ gte, lte, user_id, call_type, queue }) => ({
        url: `v1/users/call-history/fetch-recording/`,
        method: "POST",
        params: {
          gte,
          lte,
          user_id,
          call_type,
          queue
        },
      }),
    }),

    // getIntervelWiseInboundCallsReport: builder.query({
    //   query: ({ gte,lte, interval, queuename }) => ({
    //     url: `v1/reports/telephony-inbound-call-report/?gte=2024-11-20%2000:00:00&interval=15&queuename=hindi&lte=2024-11-20%2023:59:59`,
    //     method: "GET",
    //   }),
    // }),
    getIntervelWiseInboundCallsReport: builder.query({
      query: ({ gte, lte, interval, queuename }) => {

        // Construct the API request
        return {
          url: `v1/reports/telephony-inbound-call-report/?gte=${gte}%2000:00:00&interval=${interval}&queuename=${queuename}&lte=${lte}%2023:59:59`,
          method: "GET",
        };
      },
    }),
    getAllTeamsList: builder.query({
      query: ({ }) => ({
        url: `v1/users/teams/`,
        method: "GET",
      }),

    }),


    getBreakReport: builder.query({
      query: ({ gte, lte, user_id, team_id }) => ({
        url: `v1/users/call-breaks/`,
        method: "GET",
        params: {
          gte,
          lte,
          user_id,
          team_id
        },
      }),
    }),


    // getAbandonedCallReport: builder.query({
    //   query: ({ gte, lte, queuename }) => {
    //     const url = queuename
    //       ? `v1/reports/telephony-abandoned-report/?gte=${gte}%2000:00:00&lte=${lte}%2023:59:59&queuename=${queuename}&`
    //       : `v1/reports/telephony-abandoned-report/?gte=${gte}%2000:00:00&lte=${lte}%2023:59:59&`;

    //     return {
    //       url,
    //       method: "GET"
    //     };
    //   },
    // }),
    getAbandonedCallReport: builder.query({
      query: ({ gte, lte, queuename, wh }) => {
        const baseUrl = `v1/reports/telephony-abandoned-report/?gte=${gte}%2000:00:00&lte=${lte}%2023:59:59`;

        const queuePart = queuename ? `&queuename=${queuename}` : "";
        const whPart = wh !== undefined ? `&wh=${wh}` : "";

        return {
          url: `${baseUrl}${queuePart}${whPart}`,
          method: "GET",
        };
      },
    }),

    getAllCampaign: builder.query({
      query: ({ }) => ({
        url: `v1/common/campaigns/?`,
        method: "GET",
      }),

    }),

    getCampaignLeadReport: builder.query({
      query: ({ gte, lte, campaign }) => ({
        url: `v1/common/lead/leadfields/?`,
        method: "GET",
        params: {
          gte,
          lte,
          campaign
        },
      }),
    }),


    getLeadFields: builder.query({
      query: ({ gte, lte, campaign, recepients }) => ({
        url: `v1/common/lead/leadfields?`,
        method: "GET",
        params: {
          gte,
          lte,
          campaign,
          recepients
        },
      }),
    }),


    getCampaignByTeamId: builder.query({
      query: ({ selectTeam }) => ({
        url: `v1/common/campaigns/?team=${selectTeam}&`,
        method: "GET",

      }),
    }),

    getWorkflowByTeamIdAndCampaignId: builder.query({
      query: ({ selectTeam, selectedCampaign }) => {
        const baseUrl = `v1/common/campaign-name/?team=${selectTeam}`;
        const campaignFilter = selectedCampaign !== "All" ? `&campaign=${selectedCampaign}` : '';

        return {
          url: `${baseUrl}${campaignFilter}&`,
          method: "GET",
        };
      },
    }),

    getStatusByTeamIdAndCampaignIdWorkflowId: builder.query({
      query: ({ selectTeam, selectedCampaign, selectedWorkflow }) => ({
        url: `v1/common/campaign-name/?team=${selectTeam}&campaign=${selectedCampaign}&name=${selectedWorkflow}&`,
        method: "GET",

      }),
    }),


    getCampaignDispositionReport: builder.query({
      query: ({ gte, lte, campaign__team, status_type, campaign, assignee, campaign__campaign_name, id__icontains }) => ({
        url: `v1/reports/campaign-disposition-report/`,
        method: "GET",
        params: {
          gte,
          lte,
          campaign__team,
          status_type,
          campaign,
          assignee,
          campaign__campaign_name,
          id__icontains

        },
      }),
    }),
    // Social media report api 
    getSocialMediaReport: builder.query({
      query: ({ from_date, to_date, platform }) => ({
        url: `v1/reports/social-engagement/?from_date=${from_date}&to_date=${to_date}&platform=${platform}`,
        method: "GET",

      }),
    }),

    getEmailSlaReport: builder.query({
      query: ({ gte, lte, team_id, assignee }) => ({
        url: `v1/reports/email-sla-report/`,
        method: "GET",
        params: {
          gte,
          lte,
          team_id,
          assignee,
        },
      }),
    }),
       getEmailReport: builder.query({
      query: ({ gte, lte, team_id, assignee }) => ({
        url: `v1/reports/email-report/`,
        method: "GET",
        params: {
          gte,
          lte,
          team_id,
          assignee,
        },
      }),
    }),

    getEmailSLAReportDownload: builder.query({
      query: ({
        from_date,
        to_date,
        page,
        page_size,
       
        team_id,
        assignee,
      }) => ({
        url: `v1/reports/download/email/sl-report/`,
        method: "GET",
        params: {
          from_date,
          to_date,
          page,
          page_size,
          team_id,
          assignee,
        },
      }),
    }),

    getEmailReportDownload: builder.query({
      query: ({
        from_date,
        to_date,
        page,
        page_size,
       
        team_id,
        assignee,
      }) => ({
        url: `v1/reports/download/email/report/`,
        method: "GET",
        params: {
          from_date,
          to_date,
          page,
          page_size,
          team_id,
          assignee,
        },
      }),
    }),

    getTicketLifeCycleReportDownload: builder.query({
      query: ({
        from_date,
        to_date,
        page,
        page_size,
        workflow_id,
        team_ids,
        assignee,
      }) => ({
        url: `v1/reports/download/ticket/lifecycle/`,
        method: "GET",
        params: {
          from_date,
          to_date,
          page,
          page_size,
          workflow_id,
          team_ids,
          assignee,
        },
      }),
    }),

    getIssueTypeWiseTATReportDownload: builder.query({
      query: ({
        from_date,
        to_date,
        page,
        page_size,
        report_type,
        team_ids,
        workflow_id,
        status,
      }) => ({
        url: `v1/reports/download/ticket/sla-reports/`,
        method: "GET",
        params: {
          from_date,
          to_date,
          page,
          page_size,
          report_type,
          team_ids,
          workflow_id,
          status,
        },
      }),
    }),

    getUserLoginLogoutReportDownload: builder.query({
      query: ({ from_date, to_date, page, page_size, user_id }) => ({
        url: `v1/reports/download/telephony/user-login-logout/`,
        method: "GET",
        params: {
          from_date,
          to_date,
          page,
          page_size,
          user_id,
        },
      }),
    }),

    getAgentPerformanceReportDownload: builder.query({
      query: ({ from_date, to_date, page, page_size, call_type, user_id }) => ({
        url: `v1/reports/download/telephony/agent-performance/`,
        method: "GET",
        params: {
          from_date,
          to_date,
          page,
          page_size,
          call_type,
          user_id,
        },
      }),
    }),

    getCallDetailsReportDownload: builder.query({
      query: ({
        from_date,
        to_date,
        page,
        page_size,
        call_type,
        user_id,
        queue,
      }) => ({
        url: `v1/reports/download/telephony/call-details/`,
        method: "GET",
        params: {
          from_date,
          to_date,
          page,
          page_size,
          call_type,
          user_id,
          queue,
        },
      }),
    }),

    getIntervalWiseInboundCallsReportDownload: builder.query({
      query: ({ date, page, page_size, interval, queues, wh }) => ({
        url: `v1/reports/download/telephony/interval-wise-inbound-calls/`,
        method: "GET",
        params: {
          date,
          page,
          page_size,
          interval,
          queues,
          wh,
        },
      }),
    }),

    getBreakReportDownload: builder.query({
      query: ({ from_date, to_date, page, page_size, user_id, team_id }) => ({
        url: `v1/reports/download/telephony/agent-breaks/`,
        method: "GET",
        params: {
          from_date,
          to_date,
          page,
          page_size,
          user_id,
          team_id,
        },
      }),
    }),

    getCampaignLeadReportDownload: builder.query({
      query: ({ from_date, to_date, page, page_size, campaign }) => ({
        url: `v1/reports/download/leads/summary/`,
        method: "GET",
        params: {
          from_date,
          to_date,
          page,
          page_size,
          campaign,
        },
      }),
    }),

    getAbandonedCallReportDownload: builder.query({
      query: ({ gte, lte, page, page_size, queuename, wh }) => ({
        url: `v1/reports/download/reports/telephony-abandoned-report/`,
        method: "GET",
        params: {
          gte,
          lte,
          page,
          page_size,
          queuename,
          wh,
        },
      }),
    }),

    getDownloaderReports: builder.query({
      query: ({ page, page_size }) => ({
        url: `v1/reports/report-download-status/`,
        method: "GET",
        params: {
          page,
          page_size,
        },
      }),
    }),

    incrementReportDownloadCount: builder.mutation({
      query: (reportId) => ({
        url: `v1/reports/report-download-status/${reportId}/increment-download-count/`,
        method: "PATCH",
      }),
    }),


    getTicketSlVolumeReport: builder.query({
      query: ({
        gte,
        lte,
        sl_type,
        team_id,
        workflow_id,
        tag,
        tag_id,
        priority,
        workflow_status,
      }) => ({
        url: `v1/reports/ticket-sl-volume-report/`,
        method: "GET",
        params: {
          gte,
          lte,
          sl_type,
          team_id,
          workflow_id,
          tag,
          tag_id,
          priority,
          workflow_status,
        },
      }),
    }),

    getTicketTagSlReport: builder.query({
      query: ({ gte, lte, team_id, workflow_id, tag_id, tag_ids }) => ({
        url: `v1/reports/ticket-tag-sl-report/`,
        method: "GET",
        params: {
          gte,
          lte,
          team_id,
          workflow_id,
          ...(tag_id != null && tag_id !== "" ? { tag_id } : {}),
          ...(tag_ids != null && tag_ids !== "" ? { tag_ids } : {}),
        },
      }),
    }),

    getTicketPrioritySlReport: builder.query({
      query: ({ gte, lte, team_id, workflow_id, priority, priorities }) => ({
        url: `v1/reports/ticket-priority-sl-report/`,
        method: "GET",
        params: {
          gte,
          lte,
          team_id,
          workflow_id,
          ...(priority != null && priority !== "" ? { priority } : {}),
          ...(priorities != null && priorities !== "" ? { priorities } : {}),
        },
      }),
    }),

    getTicketWorkflowSlReport: builder.query({
      query: ({
        gte,
        lte,
        team_id,
        workflow_id,
        workflow_status,
        workflow_statuses,
      }) => ({
        url: `v1/reports/ticket-workflow-sl-report/`,
        method: "GET",
        params: {
          gte,
          lte,
          team_id,
          workflow_id,
          ...(workflow_status != null && workflow_status !== ""
            ? { workflow_status }
            : {}),
          ...(workflow_statuses != null && workflow_statuses !== ""
            ? { workflow_statuses }
            : {}),
        },
      }),
    }),


  }),
});

export const {
  useGetAllTeamsQuery,
  useGetAllWorkflowsQuery,
  useGetAllAssigneeBySelectedTeamIdQuery,
  useGetAllWorkflowSelectedTeamIdQuery,
  useGetAllTeamsSelectedWorkflowIdQuery,
  useGetTicketLifeCycleReportQuery,
  useGetIssueTypeWiseTATReportQuery,
  useGetSubIssueTypeWiseTATReportQuery,
  useGetDepartmentWiseTATReportQuery,
  useGetAuditTicktetWiseReportQuery,
  useGetLatestStatusReportQuery,
  useGetLoginAndLogoutReportQuery,
  useGetAllUserListQuery,
  useGetAgentPerformanceReportQuery,
  useGetAllQueueQuery,
  useGetCallDetailsReportQuery,
  useGetIntervelWiseInboundCallsReportQuery,
  useGetAllTeamsListQuery,
  useGetBreakReportQuery,
  useGetAbandonedCallReportQuery,
  useGetAllCampaignQuery,
  useGetCampaignLeadReportQuery,
  useGetCampaignByTeamIdQuery,
  useGetWorkflowByTeamIdAndCampaignIdQuery,
  useGetStatusByTeamIdAndCampaignIdWorkflowIdQuery,
  useGetCampaignDispositionReportQuery,
  useGetLeadFieldsQuery,
  useGetSocialMediaReportQuery,
  useGetEmailSlaReportQuery,
  useGetEmailReportQuery,
  useGetCallDetailsReportfetchrecordingQuery,
  useLazyGetCallDetailsReportfetchrecordingQuery,
  useGetEmailSLAReportDownloadQuery,
  useLazyGetEmailSLAReportDownloadQuery,
 
  useLazyGetEmailReportDownloadQuery,
  
  useLazyGetTicketLifeCycleReportDownloadQuery,
  useLazyGetIssueTypeWiseTATReportDownloadQuery,
  useLazyGetUserLoginLogoutReportDownloadQuery,
  useLazyGetAgentPerformanceReportDownloadQuery,
  useLazyGetCallDetailsReportDownloadQuery,
  useLazyGetIntervalWiseInboundCallsReportDownloadQuery,
  useLazyGetBreakReportDownloadQuery,
  useLazyGetCampaignLeadReportDownloadQuery,
  useLazyGetAbandonedCallReportDownloadQuery,
  useGetDownloaderReportsQuery,
  useIncrementReportDownloadCountMutation,
  useGetTicketSlVolumeReportQuery,
  useGetTicketTagSlReportQuery,
  useGetTicketPrioritySlReportQuery,
  useGetTicketWorkflowSlReportQuery,
} = getReportTicketsApi;